import { Typography } from '@mui/material';
import { TypographyProps } from '@mui/material/Typography';
import React from 'react';

export function Body(props: TypographyProps): JSX.Element {
  return (
    <Typography variant="body2" {...props}>
      {props.children}
    </Typography>
  );
}

export function H6(props: TypographyProps): JSX.Element {
  return (
    <Typography variant="h6" {...props}>
      {props.children}
    </Typography>
  );
}
